import api from './api';
import { Sale, SaleFormData, SalesHistoryItem } from '../types/Sales';

export const salesService = {
  getAll: async (): Promise<Sale[]> => {
    const response = await api.get<Sale[]>('/sales');
    return response.data;
  },

  getById: async (id: number): Promise<Sale> => {
    const response = await api.get<Sale>(`/sales/${id}`);
    return response.data;
  },

  create: async (data: SaleFormData): Promise<Sale> => {
    const response = await api.post<Sale>('/sales', data);
    return response.data;
  },

  update: async (id: number, data: SaleFormData): Promise<Sale> => {
    const response = await api.put<Sale>(`/sales/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/sales/${id}`);
  },

  getHistory: async (params: {
    startDate: string;
    endDate: string;
    barcode?: string;
  }): Promise<SalesHistoryItem[]> => {
    const response = await api.get<SalesHistoryItem[]>('/sales/history', {
      params,
    });
    return response.data;
  },
};
